import { Component, OnInit } from '@angular/core';
import { IWallpaper } from 'src/app/interfaces/ux/wallpaper.interface';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-wallpaper',
  templateUrl: './wallpaper.component.html',
  styleUrls: ['./wallpaper.component.scss']
})
export class WallpaperComponent implements OnInit {

  constructor(private theme: ThemeService) {
  }

  ngOnInit() {
  }

  get wallpaper(): IWallpaper {
    return this.theme.wallpaper;
  }

  get preload() {
    return this.wallpaper.ld || this.wallpaper.hd;
  }

  get wallpaperString() {
    const wp = [this.wallpaper.hd, this.wallpaper.ld].filter(m => m && m !== "").map(m => `url(${m})`);
    return wp.join(",");
  }
}
